import { API_BASE_URL, API_PATHS, getApiPaths } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class SetMarksService {

  static setMarks(item) {

    let api = '';
    api = `${API_BASE_URL}${API_PATHS.setMarks}`;

    return axiosInstance
      .post(api, item)
  }

  static editSetMarks(data) {

    let api = '';
    api = `${API_BASE_URL}${API_PATHS.editSetMarks}`;
    return axiosInstance
      .put(api, data)

  }

  static deleteSetMarks(id) {

    let api = '';
    api = `${API_BASE_URL}${API_PATHS.deleteSetMarks}?id=${id}`;

    return axiosInstance
      .delete(api)
  }


  static getSetMarks(item) {
    const user = JSON.parse(localStorage.getItem("user"));
    const dynamicPaths = getApiPaths(user?.data?.roleId?.name);


    let api = `${API_BASE_URL}${dynamicPaths.getSetMarks}`;
    const params = new URLSearchParams();

    if (item?.id) params.append("id", item.id);
    if (item?.standardId) params.append("standardId", item.standardId);
    if (item?.session) params.append("session", item.session);
    if (item?.examId) params.append("examId", item.examId);

    if ([...params].length > 0) {
      api += `?${params.toString()}`;
    }

    return axiosInstance.get(api);
  }




}

export default SetMarksService;
